(function () {
  function getBadgeConfig() {
    var configEl = document.getElementById('rebuy-product-carousel-badge-config');
    if (!configEl) return null;

    try {
      return JSON.parse(configEl.textContent);
    } catch (error) {
      return null;
    }
  }

  function handleize(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function parseJsonAttribute(value, fallback) {
    if (!value) return fallback;

    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function normalizeTags(value) {
    if (Array.isArray(value)) {
      return value.map(function (tag) { return String(tag).trim(); }).filter(Boolean);
    }

    return String(value || '')
      .split(/\|\||,/)
      .map(function (tag) { return tag.trim(); })
      .filter(Boolean);
  }

  function buildBadgeHtml(label, extraClass, styles, colorScheme) {
    var styleAttr = '';
    var className = 'Card_product_media_customtags_innerloops_innerboxs_new';
    
    if (colorScheme) {
      className += ' color-' + colorScheme;
    }

    if (extraClass) {
      className += ' ' + extraClass;
    }

    if (styles && (styles.background || styles.color)) {
      styleAttr = ' style="'
        + (styles.background ? 'background: ' + escapeHtml(styles.background) + ';' : '')
        + (styles.color ? ' color: ' + escapeHtml(styles.color) + ';' : '')
        + '"';
    }

    return '<div class="Card_product_media_customtags_innerloops_mainboxs_new"><div class="' + className + '"' + styleAttr + '>' + escapeHtml(label) + '</div></div>';
  }

  function buildSaveBadge(price, compareAtPrice, available, config) {
    var currentPrice = Number(price || 0);
    var comparePrice = Number(compareAtPrice || 0);

    if (!available || !(comparePrice > currentPrice && currentPrice > 0)) return '';

    var content = '';
    var styleAttr = '';

    if (config.showDiscountPercentage) {
      var discountPercent = Math.round(((comparePrice - currentPrice) * 100) / comparePrice);
      content = 'save ' + discountPercent + '%';
      styleAttr = ' style="background:' + escapeHtml(config.showDiscountPercentageBackground || '') + '; color:' + escapeHtml(config.showDiscountPercentageText || '') + ';"';
    } else {
      var savingAmount = ((comparePrice - currentPrice) / 100).toLocaleString('en-GB', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP'
      });
      content = 'save ' + savingAmount;
    }

    return '<div class="Card_product_media_customtags_innerloops_mainboxs_new"><div class="Card_product_media_customtags_innerloops_innerboxs_new save_price_new"' + styleAttr + '>' + escapeHtml(content) + '</div></div>';
  }

  function renderRebuyProductBadges(root) {
    var scope = root && root.nodeType === 1 ? root : document;
    var config = getBadgeConfig();

    if (!config) return;

    scope.querySelectorAll('.rebuy-featured-collection-widget .card__badge[data-product-tags]').forEach(function (badgeEl) {
      var tags = normalizeTags(badgeEl.dataset.productTags);
      var templateSuffix = badgeEl.dataset.templateSuffix || '';
      var available = badgeEl.dataset.available === 'true';
      var customLabels = tags
        .filter(function (tag) { return tag.indexOf('_label_') !== -1 && tag.charAt(0) === '_'; })
        .map(function (tag) { return tag.replace('_label_', ''); })
        .filter(function (tag) { return handleize(tag) !== handleize(config.soldOutLabel); });
      var html = '';

      function appendCustomLabels() {
        customLabels.forEach(function (label) {
          var styles = config.tagStyles[handleize(label)] || {};
          var extraClass = handleize(label) === handleize(config.soldOutLabel) ? 'sold-out-tag' : '';
          html += buildBadgeHtml(label, extraClass, styles, config.saleBadgeColorScheme);
        });
      }

      if (templateSuffix === 'bridesmaid-pouch') {
        if (customLabels.length) {
          appendCustomLabels();
        } else if (!available) {
          html += buildBadgeHtml(config.soldOutLabel, '', config.tagStyles[handleize(config.soldOutLabel)] || {}, config.saleBadgeColorScheme);
        }
      }

      html += buildSaveBadge(badgeEl.dataset.price, badgeEl.dataset.compareAtPrice, available, config);

      if (templateSuffix !== 'bridesmaid-pouch') {
        if (customLabels.length) {
          appendCustomLabels();
        } else if (!available) {
          html += buildBadgeHtml(config.soldOutLabel, '', config.tagStyles[handleize(config.soldOutLabel)] || {}, config.saleBadgeColorScheme);
        }
      }

      badgeEl.innerHTML = html;
      badgeEl.style.display = html ? 'flex' : 'none';
    });
  }

  function initRebuyProductCarousel(root) {
    if (typeof Swiper === 'undefined') return;

    var scope = root && root.nodeType === 1 ? root : document;

    scope.querySelectorAll('.rebuy-product-carousel-slider').forEach(function (sliderElement) {
      if (sliderElement.swiper) return;

      var navId = sliderElement.dataset.sliderId;

      new Swiper(sliderElement, {
        loop: true,
        grabCursor: true,
        spaceBetween: 26,
        slidesPerGroup: 5,
        slidesPerView: 5,
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
          forceToAxis: !0
        },
        navigation: {
          nextEl: `.swiper-button-next[data-nav-id="${navId}"]`,
          prevEl: `.swiper-button-prev[data-nav-id="${navId}"]`,
        },
        breakpoints: {
          0: {
            slidesPerGroup: 1,
            slidesPerView: "auto",
            spaceBetween: 20,
          },
          750: {
            slidesPerGroup: 1,
            slidesPerView: 3,
            spaceBetween: 26,
          },
          990: {
            slidesPerGroup: 1,
            slidesPerView: 4,
          },
          1200: {
            slidesPerGroup: 1,
            slidesPerView: 5
          },
          1441: {
            slidesPerGroup: 1,
            slidesPerView: 5,
            freeMode: !0
          }
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initRebuyProductCarousel(document);
    renderRebuyProductBadges(document);
  });

  var rebuyProductCarouselObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        initRebuyProductCarousel(node);
        renderRebuyProductBadges(node);
      });
    });
  });

  rebuyProductCarouselObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
